import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../AuthProvider';
import './NavBar.css';
import logo from '../assets/logo.png';

const NavBar = () => {
  const { user, login, logout } = useAuth();

  return (
    <div className="navbar">
      <div className="navbar-logo">
        <Link to={"/"}>
          <img src={logo} alt="Platform Logo" />
        </Link>
      </div>
      <div className="navbar-links">
        {user && <Link to="/interviews" className="nav-link">Interviews</Link>}
        <Link to="/questions" className="nav-link">Questions</Link>
        <Link to="/pricing" className="nav-link">Pricing</Link>
      </div>
      <div className="navbar-auth">
        {!user ? (
          <>
            <button className="nav-button" onClick={login}>
              Login
            </button>
            <button className="nav-button get-started" onClick={login}>
              Get Started
            </button>
          </>
        ) : (
          <>
            <button className="nav-button" onClick={logout}>
              Logout
            </button>
            <Link to="/account" className="nav-button account-button">
              Account
            </Link>
          </>
        )}
      </div>
    </div>
  );
};

export default NavBar;